import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PAGE_SIZE_OPTIONS } from 'src/app/shared/utils';
import { OrderStatus, EDPStatus, EDPStatusLabel } from 'src/app/shared/constants/constants';
import { PageEvent } from '@angular/material/paginator';
import { debounceTime, Subject } from 'rxjs';
import { isEmpty } from 'lodash';
import { OmsServiceService } from '../service/oms-service.service';
import { StorageService } from 'src/app/services/storage/storage.service';
interface Order {
  edpStatus?: string;
  sortBy?: string;
  sortDirection?: string;
  page?: number;
  size?: number;
  searchText?: string;
  customerId?: number;
}
@Component({
  selector: 'app-oms-list',
  templateUrl: './oms-list.component.html',
  styleUrls: ['./oms-list.component.scss'],
})
export class OmsListComponent implements OnInit {
  omsData: any;
  baseUrl = environment.BASE_URL;
  getOms: any = [];
  orderType!: OrderStatus;
  OrderStatus = OrderStatus;
  EDPStatus = EDPStatus;

  totalActiveOms!: number;
  pageSizeActive = 10;
  pageIndexActive = 0;

  totalCompletedOms!: number;
  pageSizeCompleted = 10;
  pageIndexCompleted = 0;

  totalInProgressOms!: number;
  pageSizeInProgress = 10;
  pageIndexInProgress = 0;

  allTabsOmsData: any = {};
  currentTab = OrderStatus.IN_PROGRESS;

  payLoad: Order = {};
  PAGE_SIZE_OPTIONS: any = PAGE_SIZE_OPTIONS;
  searchText = '';
  private searchInput$: Subject<string> = new Subject();

  constructor(
    private omsService: OmsServiceService,
    private storageService: StorageService,
  ) {}

  ngOnInit() {
    // this.getOmsList(OrderStatus.ACTIVE, this.pageIndexActive, this.pageSizeActive, true);
    this.getOmsList(
      OrderStatus.COMPLETED,
      this.pageIndexCompleted,
      this.pageSizeCompleted,
      true,
    );
    this.getOmsList(
      OrderStatus.IN_PROGRESS,
      this.pageIndexInProgress,
      this.pageSizeInProgress,
      true,
    );
    this.fetchTab();
    this.setupSearchDebouncer();
  }

  getOmsList(
    orderType: OrderStatus,
    pageIndex: number,
    pageSize: number,
    onLoad = false,
    filter = '',
  ) {
    this.orderType = orderType;

    const custId = Number(sessionStorage.getItem('customercompanyId'));

    this.payLoad = {
      ...this.payLoad,
      sortBy: 'id',
      page: pageIndex,
      size: pageSize,
      customerId: Number(this.storageService.getLocalStorage('customercompanyId')),
    };

    if (orderType === 'ACTIVE') {
      if (!filter) {
        delete this.payLoad.edpStatus;
      } else {
        this.payLoad = { ...this.payLoad, edpStatus: filter };
      }
    } else {
      this.payLoad = {
        ...this.payLoad,
        edpStatus: orderType,
      };
    }

    this.omsService.getAll(this.payLoad).subscribe((data: any) => {
      switch (orderType) {
        case OrderStatus.ACTIVE:
          this.totalActiveOms = data?.response?.totalElements;
          this.allTabsOmsData[OrderStatus.ACTIVE] = data?.response?.list;
          break;
        case OrderStatus.COMPLETED:
          this.totalCompletedOms = data?.response?.totalElements;
          this.allTabsOmsData[OrderStatus.COMPLETED] = data?.response?.list;
          break;
        case OrderStatus.IN_PROGRESS:
          this.totalInProgressOms = data?.response?.totalElements;
          this.allTabsOmsData[OrderStatus.IN_PROGRESS] = data?.response?.list;
          break;
      }

      if (!onLoad) {
        this.setCurrentTab(orderType);
      }
      this.getOms = this.allTabsOmsData[this.currentTab];
    });
  }

  filterBy(edpStatus: any, allOrders?: any) {
    if (allOrders == 'allOrder') {
      delete this.payLoad.edpStatus;
      this.getOmsList(this.orderType, this.pageIndexActive, this.pageSizeActive);
    } else {
      this.payLoad.edpStatus = edpStatus;
      this.getOmsList(
        this.orderType,
        this.pageIndexActive,
        this.pageSizeActive,
        false,
        edpStatus,
      );
    }
  }

  fetchTab() {
    if (this.omsService.omsCurrentTab) this.currentTab = this.omsService.omsCurrentTab;
  }

  onPageChangeActiveOms(event: PageEvent) {
    this.pageIndexActive = event.pageIndex;
    this.pageSizeActive = event.pageSize;
    this.getOmsList(OrderStatus.ACTIVE, this.pageIndexActive, this.pageSizeActive);
  }

  onPageChangeCompletedOms(event: PageEvent) {
    this.pageIndexCompleted = event.pageIndex;
    this.pageSizeCompleted = event.pageSize;
    this.getOmsList(
      OrderStatus.COMPLETED,
      this.pageIndexCompleted,
      this.pageSizeCompleted,
    );
  }

  // Handle page change for In Progress tab
  onPageChangeInProgressOms(event: PageEvent) {
    this.pageIndexInProgress = event.pageIndex;
    this.pageSizeInProgress = event.pageSize;
    this.getOmsList(
      OrderStatus.IN_PROGRESS,
      this.pageIndexInProgress,
      this.pageSizeInProgress,
    );
  }

  searchOms() {
    this.payLoad.searchText = this.searchText;

    if (!isEmpty(this.searchText)) {
      this.getOmsList(this.orderType, this.pageIndexActive, this.pageSizeActive);
    } else {
      this.getOmsList(this.orderType, this.pageIndexActive, this.pageSizeActive);
    }
  }

  clearTextSearch(): void {
    const event = {
      target: {
        value: '',
      },
    };
    this.searchText = '';
    this.searchOms();
  }

  setupSearchDebouncer() {
    this.searchInput$.pipe(debounceTime(1000)).subscribe((term: string) => {
      this.searchText = term;
      this.searchOms();
    });
  }

  searchOmsBy(event: any): void {
    this.searchText = event.target.value;
    this.searchInput$.next(this.searchText);
  }

  setCurrentTab(cuurentTab: OrderStatus) {
    this.currentTab = cuurentTab;
    this.omsService.omsCurrentTab = cuurentTab;
  }

  getEdpStatusLabel(edpStatus: EDPStatus): EDPStatusLabel {
    return EDPStatusLabel[edpStatus];
  }

  getEdpRoute(id: number) {
    let route = '';
    if (this.currentTab === OrderStatus.IN_PROGRESS) {
      route = `/oms/ordersInProgress/${id}`;
    } else {
      route = `/oms/orders/${id}`;
    }

    return route;
  }
}
